import { FC, ReactNode } from 'react';

import { useAppStore } from 'entities/user/model/store/useAppStore';
import { FullPageLoader } from 'shared/ui/Loader/FullPageLoader';

interface LoaderProviderProps {
	children: ReactNode;
}

export const LoaderProvider: FC<LoaderProviderProps> = ({ children }) => {
	const { isLoading } = useAppStore();

	return (
		<>
			{isLoading && <FullPageLoader />}
			{children}
		</>
	);
};
